module.exports = __webpack_public_path__ + "static/media/Edit.36959436.svg";